import cn from 'classnames';
import React from 'react';
import styles from './termsCondition.module.scss';

const Section = ({ children }: { children: React.ReactNode }) => <section>{children}</section>;
Section.Title = function SectionTitle({ children }: { children: React.ReactNode }) {
  return <div className="section-title">{children}</div>;
};
Section.Paragraph = function SectionParagraph({ children }: { children: React.ReactNode }) {
  return <p className="paragraph">{children}</p>;
};
const ListItem = {
  Title: function ListItemTitle({ children }: { children: React.ReactNode }) {
    return <div>{children}</div>;
  },
  Step: function ListItemStep({ children }: { children: React.ReactNode }) {
    return <div>{children}</div>;
  },
};
const Highlight = ({ children }: { children: React.ReactNode }) => (
  <span className="font-bold">{children}</span>
);

export const TermsCondition = () => {
  return (
    <>
      <main className={cn('container text-left', styles.container)}>
        <h1 className="main-title">Terms and Conditions</h1>
        <Section>
          <Section.Paragraph>
            Please read the following Terms and Conditions carefully before using this website. By
            visiting the <a href="www.securetradeclub.com">www.securetradeclub.com</a> website, you
            agree to the terms of this agreement which will bind you.
          </Section.Paragraph>
          <Section.Paragraph>
            These Terms and Conditions (the “Terms”) constitute a legal agreement between you and
            Secure Trade Club a company incorporated in Florida with seat in Volusia County
            (hereinafter, “we”, “our” or “us”) governing the use of our website or any of the
            contents therein and our Services. We license use of our website or any of the contents
            therein and our Services to you on the basis of these Terms. We do not sell, our website
            or any of the contents therein to you, and we remain the owner of our website or any of
            the contents therein at all times.
          </Section.Paragraph>
          <Section.Paragraph>
            Supplemental terms and conditions or documents that may be posted from time to time are
            hereby expressly incorporated herein by reference. We reserve the right, in our sole
            discretion, to make changes or modifications to these Terms and Conditions at any time
            and for any reason.
          </Section.Paragraph>
          <Section.Paragraph>
            It is your responsibility to periodically review these Terms and Conditions to stay
            informed of updates. You will be subject to, and will be deemed to have been made aware
            of and to have accepted, the changes in any revised Terms and Conditions by your
            continued use of our website and service after the date such revised Terms and
            Conditions are posted.
          </Section.Paragraph>
          <Section.Paragraph>
            The information provided is not intended for distribution to or use by any person or
            entity in any jurisdiction or country where such distribution or use would be contrary
            to law or regulation or which would subject us to any registration requirement within
            such jurisdiction or country.
          </Section.Paragraph>
          <Section.Paragraph>
            You should print a copy of these Terms for future reference.
          </Section.Paragraph>
          <ol>
            <li>
              <div>
                <Highlight>Interpretation</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    The definitions in this paragraph apply in these Terms:
                  </ListItem.Title>
                  <ListItem.Step>
                    “Personal Data” has the meaning given under the GDPR and the CCPA.
                  </ListItem.Step>
                  <ListItem.Step>
                    “Related Content” means information, content, materials, products and other
                    services included on or otherwise made available to you through the Services.
                  </ListItem.Step>
                  <ListItem.Step>
                    “Services”: means our services offered via our website or otherwise by us and
                    any other software provided by us in connection with any of the foregoing.
                  </ListItem.Step>
                  <ListItem.Step>
                    “User”: means an individual who accesses and uses an Account.
                  </ListItem.Step>
                  <ListItem.Step>
                    “Exchange”: means an act of giving one thing and receiving another in return.
                  </ListItem.Step>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Intellectual Property</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    All Content included on the Platform, unless uploaded by Users, including, but
                    not limited to, text, graphics, logos, icons, images, sound clips, video clips,
                    data compilations, page layout, underlying code and software is the property of
                    Secure Trade Club, our affiliates or other relevant third parties.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    By continuing to use the Platform you acknowledge that such material is
                    protected by applicable United States and International intellectual property
                    and other relevant laws.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You may not reproduce, copy, distribute, store or in any other fashion re-use
                    material from the Platform unless otherwise indicated on the Platform or unless
                    given express written permission to do so by Secure Trade Club.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You acknowledge that all intellectual property rights in our Platform anywhere
                    in the world belong to us, that rights in our Platform are licensed (not sold)
                    to you, and that you have no rights in, or to, our Platform other than the right
                    to use them in accordance with these Terms.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    Any intellectual property rights in content uploaded by you to our Platform
                    shall continue to belong to you or their respective owners. You agree that you
                    grant us a royalty-free and non-exclusive license to use, reproduce, publish and
                    display such intellectual property rights for the purposes of performing the
                    Services, promotional purposes, internal administrative purposes and any other
                    purposes set out in these Terms, including for the purpose of improving the
                    Services and our responses to users of the Platform.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You acknowledge that you have no right to have access to our Platform in source
                    code form.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You must not modify the paper or digital copies of any materials you have
                    printed off or downloaded from our Platform in any way, and you must not use any
                    illustrations, photographs, video or audio sequences or any graphics separately
                    from any accompanying text.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You must not use any part of the content on our Platform for commercial purposes
                    not specified on our Platform without obtaining a license to do so from us or
                    our licensors.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    If you print off, copy or download any content on our Platform in breach of this
                    Agreement, your right to use our Platform will cease immediately, and you must,
                    at our option, return or destroy any copies of the materials you have made.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Use of our Platform</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    The provisions set out in these Terms govern your access to and your use of our
                    Platform and shall constitute a legally binding agreement between you and us. We
                    may change such terms from time to time and shall notify you accordingly if we
                    do. If you do not agree to such terms, you must not use our Platform.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    Subject to you agreeing to abide by these Terms, we hereby grant to you a
                    revocable, non-exclusive and non-transferable license to use our Platform on
                    these Terms.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    By registering for an Account, which involves providing us with certain
                    mandatory and voluntary information as required for a successful registration
                    and using our Platform, you agree and acknowledge that:
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    you have read the terms set out in these Terms and agree to be bound by and
                    comply with them; and
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    you shall ensure that all Users of your Account abide by these Terms.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You are responsible for maintaining the confidentiality of your Account and you
                    are responsible for all activities that occur under your Account. You agree that
                    all actions carried out by any person through your Account shall be deemed to be
                    an act carried out by you, and you shall ensure that all persons who have access
                    to and use your Account are authorized to do so. We are not responsible for any
                    loss, damage or liabilities arising as a result of or in connection with the
                    wrongful, fraudulent or illegal use of your Account.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    We reserve the right to, without any notice, explanation, or liability and in
                    our sole discretion, refuse to allow you or suspend your access to our Platform
                    or your Account at any time, or remove or edit content (including content
                    submitted by you) on our Platform or on any of our affiliated websites
                    (including social media pages).
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    We reserve the right to change, modify, suspend or discontinue any portion of
                    the Services, our Platform or any other products, services, affiliated websites
                    (including social media pages) and/or other software provided by us in
                    connection with any of the foregoing at any time. You agree that access to or
                    operation of any of the foregoing may from time to time be interrupted or
                    encounter technical difficulties.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    Save to the extent permitted by us in writing, you are not permitted to use, or
                    submit any content to, our Platform or any of our affiliated websites to
                    advertise, promote or market any products or services of any third party or
                    yourself.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Exchange service</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    Secure Trade Club offers a service on www.securetradeclub.com with which
                    collectibles can be bought, sold and exchanged or traded . When offering these
                    articles, clause 8 in particular must be observed. With each exchange
                    transaction a contract is concluded directly between two members: the provider
                    of an article and the member requesting the article. Secure Trade Club is not
                    involved in the concluded contracts and merely provides the platform for the
                    Secure Trade Club Service. The fulfillment of the contract therefore takes place
                    exclusively between the Members.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    Subject to the terms and conditions in this Agreement, during the Agreement
                    Term, we hereby grant you limited, non-exclusive, non-transferable,
                    non-sublicensable, worldwide, and revocable rights to access and use the
                    Services solely for your personal, internal business use, unless Secure Trade
                    Club has agreed with you otherwise in a separate agreement.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You agree your access and use the Services is not contingent on delivery of any
                    future functionality or features or the delivery of any other services.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You acknowledge that Secure Trade Club does not provide those services and that
                    all such services are provided by independent third-party's who are not employed
                    by Secure Trade Club or any of its affiliates.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Registration</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    In order to use the services, registration is required and also includes
                    agreement to these Terms and Conditions. Registration constitutes a contract
                    between Secure Trade Club and the Member for the use of the Platform .
                    Registration is only permitted to legal entities and natural persons of
                    unlimited legal capacity. In particular, minors are not permitted to register.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>Each person is only permitted one registration.</ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    The registration data must be complete and correct. The registration of a legal
                    entity may only be carried out by a natural person authorized to represent the
                    entity, who must be named.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    If a change occurs in the data provided after registration, the member is
                    obliged to correct his or her details immediately.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    When registering, the member chooses a member name ("pseudonym") and a password.
                    This must be kept secret in order to avoid any misuse. In case of suspicion of
                    misuse, Secure Trade Club must be informed immediately.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Interactions with Users</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    The Portal functions as a venue to connect buyers, and sellers in a virtual
                    information place. As a neutral facilitator, Secure Trade Club is not directly
                    involved in the actual transactions between Users. As a result, Secure Trade
                    Club has no control over the truth, accuracy, quality, legality, or safety of
                    postings made by users of the Portal.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    Secure Trade Club shall have no responsibility to confirm the identity of
                    members. Secure Trade Club shall also have no responsibility to confirm or
                    verify the qualifications, background, or abilities of users of the Portal.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You shall at all times exercise common sense and good judgment when dealing with
                    any user of the Portal.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    The Portal may provide you with the ability to send messages and communications
                    to Users. You agree to use communication methods available on the Portal only to
                    send communications and materials related to the subject matter for which Secure
                    Trade Club provided the communication method, and you further agree that all
                    such communications by you shall be deemed your Content and shall be subject to
                    and governed by these Terms.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    By using any of the communications methods available on the Portal, you
                    acknowledge and agree that (a) all communications methods constitute public, and
                    not private, means of communication between you and the other party or parties,
                    (b) communications sent to or received from third partys are not endorsed,
                    sponsored or approved by Secure Trade Club (unless expressly stated otherwise by
                    Secure Trade Club), and (c) communications are not pre-reviewed, post-reviewed,
                    screened, archived or otherwise monitored by Secure Trade Club in any manner,
                    though Secure Trade Club reserves the right to do so at any time at its sole
                    discretion in accordance with the Terms. You agree that all notices, disclosures
                    and other communications that we provide to you electronically shall satisfy any
                    legal requirement that such communications be in writing.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    All User Data included in postings must refer to actual listings and comply with
                    applicable laws.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    All users are solely responsible for their career decisions and hiring
                    determinations.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Security</Highlight>
              </div>
              <p>
                You may not use this Portal or allow this Portal to be used to: a) gain unauthorized
                access to computer systems or engage in security attacks of any kind including:(i)
                against trust (such as email spoofing, password cracking, IP spooking and DNS
                poisoning); (ii) against confidentiality and integrity (by using malware such as
                computer viruses, worms, trojan horses, rootkits, keyloggers, spyware or other
                malicious programs and code); (iii) against availability (such as denial of service
                and email bombs); b) corrupt, modify or intercept electronic communications intended
                for any other person or entity; or c) interfere with or disrupt the operation of or
                this Portal. You may not avoid any limitations we place on your use of this Portal.
              </p>
            </li>
            <li>
              <div>
                <Highlight>Abuse and Illegal Behavior</Highlight>
              </div>
              <p>
                You may not use this Portal to: conduct or engage in any illegal business or
                activity; b) infringe any third- party intellectual property right (for example
                copyright, patents, trademark, trade secret or know-how); c) collect, copy or
                process information in a way that breaches data protection laws or leads to a
                wrongful breach of privacy; d) create, distribute, process or view any: (i)
                defamatory; (ii) obscene, indecent or pornographic; (ii) racist, sexist or otherwise
                discriminatory; (iv) misleading, deceptive or fraudulent; or (v) otherwise
                objectionable, offensive or illegal material.
              </p>
            </li>
            <li>
              <div>
                <Highlight>Email and Spam</Highlight>
              </div>
              <p>
                You may not use this Portal to chat or other communications in an unacceptable or
                illegal manner. For example, you may not: a) create or send hoax emails or chain
                emails; b) send unsolicited commercial email or bulk email (“spam” or “spamming”);
                c) harvest email addresses; d) use open proxies or relays to allow spamming; or e)
                impersonate someone else (“spoofing”) or falsify message header information.
              </p>
            </li>
            <li>
              <div>
                <Highlight>Disputes</Highlight>
              </div>
              <p>
                If you have any issues with a User, you should resolve the issue directly with the
                User. You should also notify us of the concern.
              </p>
            </li>
            <li>
              <div>
                <Highlight>Subject matter and scope of the user agreement</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    The use of the Platform and the extent to which individual functions and
                    services are available may be subject to certain conditions imposed by Secure
                    Trade Club. These include, for example, the correctness of the registration data
                    or proof of payment in the case of chargeable services.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    The member's entitlement to use the Platform and its functions cannot be 100%
                    guaranteed, but an availability corresponding to the state of the art is strived
                    for. Temporary limitations may result from technical malfunctions, for example
                    software or hardware errors. Secure Trade Club further reserves the right to
                    temporarily restrict its services if necessary.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    Members will be informed by e-mail about exchange requests, individual search
                    requests and innovations at Secure Trade Club.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Blocking</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    Secure Trade Club may block a member or restrict the member's rights of use if
                    the interests of the Platform or other members are violated, in particular if
                  </ListItem.Title>
                  <ol>
                    <li>
                      articles have obviously been posted incorrectly or are not in the member's
                      possession
                    </li>
                    <li>
                      the blocking is necessary to protect the interests of the members due to
                      negative evaluations
                    </li>
                    <li>offensive or illegal terms are used as pseudonyms</li>
                    <li>incorrect information was given when registering</li>
                    <li>an attempt has been made to register more than once</li>
                    <li>
                      the rights of third parties have been violated in connection with his or her
                      use of the Platform
                    </li>
                    <li>misuse the services of the Platform </li>
                    <li>the rules of the forum are violated</li>
                    <li>the posting guidelines are violated</li>
                    <li>
                      the Secure Trade Club Service is circumvented (exchanging without using
                      Platform)
                    </li>
                    <li>outstanding payments/receivables are not settled</li>
                  </ol>
                </li>
                <li>
                  <ListItem.Title>
                    If a member has been banned, this member may no longer use the Secure Trade Club
                    Service and may not register again.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Costs and fees</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    Registration and the offering of items are free of charge.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    For each exchange transaction Secure Trade Club charges the requesting member a
                    5% Payment Processing Fee.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    The item is shipped by the offering member, who is responsible for the shipping
                    costs.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    To request an item offered in the Secure Trade Club Service, are required, which
                    are obtained by sending requested items.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Charge-backs</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    You agree to contact us prior to raising a request for a charge-back or any
                    dispute with your bank or card issuer in relation to any Transaction.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    If you make a card payment through our Portal, and later dispute a legitimate
                    charge by raising a charge-back without merit or legitimate reason (as
                    determined at our sole discretion), whether fraudulently or otherwise, then we
                    reserve the right to blacklist you by providing compelling evidence to refute
                    your invalid charge-back request and or pursue legal action as the case may be.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Conclusion of contract</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    By placing an item in the Secure Trade Club Service, the member makes a binding
                    offer to conclude a contract for this item and agrees to send the item free of
                    charge.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    As soon as a member requests this item for exchange (a prerequisite for the
                    request is the availability of corresponding exchange and sufficient exchange
                    credit) and this request is confirmed, a contract for the purchase of this item
                    is concluded. Secure Trade Club will inform both members of the name and address
                    of the respective exchange partner.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    All addresses obtained through the use of the barter exchanges may only be used
                    for the bartering process. In particular, it is prohibited to pass on these data
                    to third parties or to use them for advertising purposes.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    The time frame for dispatch described in Section 10 shall apply.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Time frame for dispatch and evaluation</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    Each exchange should be processed as quickly as possible. The following time
                    limits must be observed:
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    When a provider receives an exchange request, it should confirm it within 24
                    hours. After this 24 hour period has expired, a transaction will be canceled and
                    a corresponding evaluation will be made by Secure Trade Club.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    After submitting the exchange confirmation, the requested item must reach the
                    recipient within 7 days at the latest.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    The recipient can rate the receipt of the item up to six weeks (42 days) after
                    submitting the exchange confirmation. The provider of the item then has four
                    weeks (28 days) to react to the evaluation received and to comment on it if
                    necessary.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Offenses</Highlight>
              </div>
              <p>
                In case of infringements Secure Trade Club reserves the right to block the member
                and to claim damages. The damages amount to a lump sum of USD 200,00 for the
                expenses in connection with the blocking. In the case of claims for damages, the
                blocked member is entitled to prove that lower expenses were incurred.
              </p>
            </li>
            <li>
              <div>
                <Highlight>Uploading content</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    You irrevocably and unconditionally represent and warrant that any of your
                    content uploaded to our Portal or any of the contents therein complies with our
                    Privacy Policy, the GDPR and CCPA and any other applicable laws.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You are fully responsible for your content uploaded to our Portal or any of the
                    contents therein. We will not be responsible, or liable to any third party, for:
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    the content or accuracy of any content or data uploaded by you, by us on your
                    behalf, or any other user of our Portal or any of the contents therein; or
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    the loss of any content or data (whether in physical or digital form) provided
                    to us by you. You should keep a record of all such content and data (including
                    for the avoidance of doubt any insurance policies).
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    We will only use the content uploaded by you for the purposes of carrying out
                    the Services, carrying out our obligations in this Agreement and any other
                    purpose expressly set out in this Agreement or otherwise agreed between us. We
                    will not otherwise disclose or distribute the content uploaded by you, save for
                    when required by law, a court of competent jurisdiction or any governmental or
                    regulatory authority.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    We may use the content uploaded by you for the purpose of data analytics or to
                    implement artificial intelligence or machine learning. Any such content shall be
                    anonymised and used only for the purposes of improving the Services and our
                    response to users of the Portal.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    We have the right to disclose your identity to any third party claiming that any
                    content posted or uploaded by you to our Portal or any of the contents therein
                    constitutes a violation of their rights under applicable law.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Restrictions</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    Except as expressly set out in this Agreement or as permitted by any applicable
                    law, you undertake:
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    save for internal distribution amongst your employees and persons authorized by
                    you for your internal business purposes, and any other purposes contemplated
                    under these Terms, not to reproduce, copy, modify, adapt, translate, publish,
                    display, communicate, transmit, sell, exploit or use the whole or any part of
                    any Service including our Portal or any of the contents therein or any of the
                    contents therein for any commercial or other purposes;
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    not to disassemble, decompile, reverse-engineer or create derivative works based
                    on the whole or any part of the source code of our our Portal or any of the
                    contents therein or any of the contents therein nor attempt to do any such
                    thing, or to reproduce, display or otherwise provide access to the Services, our
                    Portal or any of the contents therein or any of the contents therein, including
                    but not limited to framing, mirroring, linking, spidering, scraping or any other
                    technological means;
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    not to provide or otherwise make available our Portal or any of the contents
                    therein or any of the contents therein in whole or in part (including but not
                    limited to program listings, object and source program listings, object code and
                    source code), in any form to any person without prior written consent from us;
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    to include our copyright notice on all entire and partial copies you make of our
                    Portal or any of the contents therein on any medium;
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    to comply with all applicable technology control or export laws and regulations;
                    and
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    not to disrupt, disable, or otherwise impair the proper working of the Services,
                    our Portal or any of the contents therein or our servers, such as through
                    hacking, cyber-attacks (including but not limited to denial-of-service attacks),
                    tampering or reprogramming.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Indemnification</Highlight>
              </div>
              <p>
                The member indemnifies Secure Trade Club against all claims asserted by other
                members or third parties against Secure Trade Club due to infringement of their
                rights by offers and contents posted by the member on Secure Trade Club or due to
                the member's other use of Secure Trade Club (including the ratings submitted by the
                member). In this case, the member shall also bear the costs of the necessary legal
                defense of Secure Trade Club, including all court and Attorney's fees. This does not
                apply if the member is not responsible for the infringement.
              </p>
            </li>
            <li>
              <div>
                <Highlight>Limitation of Liability</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    Secure Trade Club is liable for damages to entrepreneurs, except in case of
                    breach of fundamental contractual obligations, only if and to the extent that
                    Secure Trade Club's legal representatives or executives are guilty of intent or
                    gross negligence. Secure Trade Club shall be liable for other vicarious agents
                    only in case of intent and to the extent that they violate essential contractual
                    obligations intentionally or by gross negligence. Except in case of intent or
                    gross negligence of legal representatives, executives or intentional behavior of
                    other vicarious agents of Secure Trade Club, there is no liability for
                    compensation of indirect damages, in particular for loss of profit.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    We are not liable for the completeness, accuracy, or correctness of any
                    information uploaded on our Portal or any of the contents therein and any
                    Related Content.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You expressly agree that your use of the Services and our Portal or any of the
                    contents therein, including reliance on any advice, is at your sole risk and not
                    for navigational purposes.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You agree not to use the Services, our Portal or any of the contents therein and
                    the Related Content for any sale purposes, and we have no liability to you,
                    whether in contract, tort (including negligence), breach of statutory duty, or
                    otherwise, arising under or in connection with these Terms (including but not
                    limited to the use of, or inability to use, the Services, our Portal or any of
                    the contents therein or any other service or software) for:
                  </ListItem.Title>
                  <ol>
                    <li>loss of profits, sales, business, or revenue;</li>
                    <li>business interruption;</li>
                    <li>loss of anticipated savings;</li>
                    <li>loss or corruption of data or information;</li>
                    <li>loss of business opportunity, goodwill or reputation; or</li>
                    <li>any other indirect or consequential loss or damage.</li>
                    <li>Nothing in these Terms shall limit or exclude our liability for:</li>
                    <li>death or personal injury resulting from our negligence; </li>
                    <li>fraud; and/or</li>
                    <li>
                      any other matter in respect of which we are prohibited under applicable law
                      from limiting or excluding our liability.
                    </li>
                    <li>
                      our Portal or any of the contents therein is not intended to serve a
                      record-keeping function, and we shall not be liable for any loss of data or
                      content.
                    </li>
                  </ol>
                </li>
                <li>
                  <ListItem.Title>
                    These Terms set out the full extent of our obligations and liabilities in
                    respect of the supply of the Services and our Portal or any of the contents
                    therein. Except as expressly stated in these Terms, there are no conditions,
                    warranties, representations or other terms, express or implied, that are binding
                    on us. Any condition, warranty, representation or other term concerning the
                    supply of the Services and our Portal or any of the contents therein which might
                    otherwise be implied into, or incorporated in, these Terms whether by statute,
                    common law or otherwise, is excluded to the fullest extent permitted by law.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Warranties</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    While we make all efforts to maintain the accuracy of the information on our
                    Portal or any of the contents therein, we provide the Services, Portal and all
                    Related Content on an “as is” and “as available” basis, unless otherwise
                    specified in writing. We make no representations or warranties of any kind,
                    express or implied, as to the operation of any of the foregoing, unless
                    otherwise specified in writing.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    To the full extent permissible by law, we disclaim all warranties, express or
                    implied, relating to our Portal or any of the contents therein or any Services,
                    including but not limited to implied warranties of merchantability and fitness
                    for a particular purpose. We do not warrant that the Services, our Portal or any
                    of the contents therein, the Related Content, or electronic communications sent
                    by us are free of viruses or other harmful components.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    Secure Trade Club assumes no liability for the topicality, correctness,
                    completeness or quality of the information provided in our Portal or any of the
                    contents therein. Liability claims against Secure Trade Club, which refer to
                    material or immaterial nature caused by use or disuse of the information or the
                    use of incorrect and incomplete information or our Portal or any of the contents
                    therein are excluded.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    To the maximum extent permitted by law, we provide our Portal or any of the
                    contents therein the Services as is and as available. That means that except to
                    the extent expressly set forth in the Agreement, we don’t provide warranties of
                    any kind, either express or implied, including, but not limited to, we may use
                    or disclose your materials only as we describe in these Terms and our Privacy
                    Policy, non-infringement, title and fitness for a particular purpose or use.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    We do not warrant our Portal or any of the contents therein or the Services will
                    meet your requirements nor do we provide any warranty about results that may be
                    obtained by using the Services our Portal or any of the contents therein.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Management</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>We reserve the right, but not the obligation, to:</ListItem.Title>
                  <ol>
                    <li>
                      a.monitor our Portal or any of the contents therein or any of the contents
                      therein for violations of these Terms and Conditions;
                    </li>
                    <li>
                      b.take appropriate legal action against anyone who, in our sole discretion,
                      violates the law or these Terms and Conditions, including without limitation,
                      reporting such user to law enforcement authorities;
                    </li>
                    <li>
                      c.in our sole discretion and without limitation, refuse, restrict access to,
                      limit the availability of, or disable (to the extent technologically feasible)
                      any of your Contributions or any portion thereof;
                    </li>
                    <li>
                      d.in our sole discretion and without limitation, notice, or liability, to
                      remove from the Portal or otherwise disable all files and content that are
                      excessive in size or are in any way burdensome to our systems;
                    </li>
                    <li>
                      e.otherwise manage the Portal in a manner designed to protect our rights and
                      property and to facilitate the proper functioning of the Portal.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Reliance on Information</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    The Portal is intended to provide general information only and, as such, should
                    not be considered as a substitute for advice covering any specific situation.
                    You should seek appropriate advice before taking or refraining from taking any
                    action in reliance on any information contained in the Portal.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    The information provided on the Portal is not intended for distribution to or
                    use by any person or entity in any jurisdiction or country where such
                    distribution or use would be contrary to law or regulation or which would
                    subject us to any registration requirement within such jurisdiction or country.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>No Waiver</Highlight>
              </div>
              <p>
                In the event that any party to these Terms and Conditions fails to exercise any
                right or remedy contained herein, this shall not be construed as a waiver of that
                right or remedy.
              </p>
            </li>
            <li>
              <div>
                <Highlight>User Data</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    We will maintain certain data that you transmit to the Platform for the purpose
                    of managing the Platform, as well as data relating to your use of the Platform.
                    Although we perform regular routine backups of data, you are solely responsible
                    for all data that you transmit or that relates to any activity you have
                    undertaken using the Platform.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You agree that we shall have no liability to you for any loss or corruption of
                    any such data, and you hereby waive any right of action against us arising from
                    any such loss or corruption of such data.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Binding Arbitration</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    If the Parties are unable to resolve a Dispute through informal negotiations,
                    the Dispute (except those Disputes expressly excluded below) will be finally and
                    exclusively resolved by binding arbitration. YOU UNDERSTAND THAT WITHOUT THIS
                    PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN COURT AND HAVE A JURY TRIAL.{' '}
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    The arbitration shall be commenced and conducted under the Commercial
                    Arbitration Rules of the American Arbitration Association ("AAA") and, where
                    appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes
                    ("AAA Consumer Rules"), both of which are available at the AAA Web Site
                    www.adr.org.{' '}
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    Your arbitration fees and your share of arbitrator compensation shall be
                    governed by the AAA Consumer Rules and, where appropriate, limited by the AAA
                    Consumer Rules.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    The arbitration may be conducted in person, through the submission of documents,
                    by phone, or online. The arbitrator will make a decision in writing, but need
                    not provide a statement of reasons unless requested by either Party.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    The arbitrator must follow applicable law, and any award may be challenged if
                    the arbitrator fails to do so. Except where otherwise required by the applicable
                    AAA rules or applicable law.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
            <li>
              <div>
                <Highlight>Class Action Waiver</Highlight>
              </div>
              <p>
                The parties agree that (i) no arbitration proceeding hereunder whether a consumer
                dispute or a business dispute shall be certified as a class action or proceed as a
                class action, or on a basis involving claims brought in a purported representative
                capacity on behalf of the general public, other customers or potential customers or
                persons similarly situated, and (ii) no arbitration proceeding hereunder shall be
                consolidated with, or joined in any way with, any other arbitration proceeding. The
                parties agree to arbitrate a consumer dispute or business dispute on an individual
                basis and each waives the right to participate in a class action.
              </p>
            </li>
            <li>
              <div>
                <Highlight>Waiver of Jury Trial</Highlight>
              </div>
              <p>
                Each of the parties hereto hereby irrevocably waives any and all right to trial by
                jury in any legal proceeding arising out of or related to this agreement or the
                transactions contemplated hereby.
              </p>
            </li>
            <li>
              <div>
                <Highlight>Other Important Terms</Highlight>
              </div>
              <ol>
                <li>
                  <ListItem.Title>
                    We may transfer our rights and obligations under these Terms to another
                    organization, but this will not affect your rights or obligations under these
                    Terms.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    You may only transfer your rights or your obligations under these Terms to
                    another person if we agree in writing.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    No joint venture, partnership, or agency or employment relationship has arisen
                    by reason of these Terms.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    These Terms and any document expressly referred to in it constitutes the entire
                    agreement between us regarding their subject matter, and supersedes and
                    extinguishes all previous agreements, promises, assurances, warranties,
                    representations and understandings between us, whether written or oral, relating
                    to that subject matter. You agree that you shall have no remedies in respect of
                    any statement, representation, assurance or warranty (whether made innocently or
                    negligently) that is not set out in these Terms or any document expressly
                    referred to in it. You agree that you shall have no claim for innocent or
                    negligent misrepresentation or negligent misstatement based on any statement in
                    these Terms or any document expressly referred to in it.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    If we fail to insist that you perform any of your obligations under these Terms,
                    or if we do not enforce our rights against you, or if we delay in doing so, that
                    will not mean that we have waived our rights against you and will not mean that
                    you do not have to comply with those obligations. If we do waive a default by
                    you, we will only do so in writing, and that will not mean that we will
                    automatically waive any later default by you.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    Each of the conditions of these Terms operates separately. If any court or
                    competent authority decides that any of them are unlawful or unenforceable, the
                    remaining conditions will remain in full force and effect.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    These Terms, its subject matter and its formation, and any other disputes or
                    claims in connection therewith, are governed by the laws and courts of Florida.
                  </ListItem.Title>
                </li>
                <li>
                  <ListItem.Title>
                    In the event of any such disputes or claims in connection with these Terms, you
                    agree to first engage in good faith discussions with us to resolve such dispute
                    or claim.
                  </ListItem.Title>
                </li>
              </ol>
            </li>
          </ol>
        </Section>
      </main>
    </>
  );
};
